export const PageText = {
  _1: 'Do my customers really want air quality info?',
  _2: 'Air quality is a hot topic! The media is picking up the issue on a regular basis. Many people are concerned, but feel helpless and unsure how to act accordingly.'
};

export const Categories = {
  _1: {
    title: 'Positive story',
    subcategories: [
      {
        key: 0,
        subtitle: 'Empower your customers',
        text: 'aircheckr turns air quality into something positive. People are no longer defenceless. aircheckr empowers your customers to actively or passively make better decisions and actions in order to breathe better air.'
      }
    ]
  },
  _2: {
    title: 'Wide range of needs',
    quotes: [
      {
        text: 'I pay for an extensive ventilation system for my new house, but is the ventilation programmed to take the outside air quality into consideration?'
      },
      {
        text: 'I am an asthma patient and I want an air quality monitoring system that sends me alerts and suggestions to take actions.'
      },
      {
        text: 'I drive an electric car, but I am still breathing the exhaust of all other cars?'
      },
      {
        text: 'I love this house, but before I pay hundreds of thousands of euros, I want to know how the air quality is in this neighbourhood. What air will my children breathe when they play in the yard?'
      },
      {
        text: 'I just arrived at the airport, but what is the air quality when I go outside and head out for the city?'
      },
      {
        text: 'We breathe up to 8 times more when exercising. So, what is the best moment to go jogging?'
      },
      {
        text: 'I bring my daughter with the bike to school everyday, that is healthy, right?  Maybe there is a healthier route...'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/do-my-customers-really-want-air-quality-info_page.js